import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const CoachingShoutOutSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        createCoachingShoutOut: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_COACHING_SHOUTOUT,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['CoachingShoutOut','CoachingShoutOutCarousel','coachingInsightHistory','CoachingShoutOutView'],
        }),
        getLatestShoutOut: builder.query({
            query: (arg: any) => {
                const { employeenumber } = arg;
                return {
                    url: constants.GET_LATEST_SHOUTOUT,
                    params: {
                        employeenumber,
                    },
                };
            },
            providesTags: ['CoachingShoutOut'],
        }),
        getTeamMembersData: builder.query({
            query: (arg: any) => {
                const { employeeNo, role } = arg;
                return {
                    url: constants.COACHING_TEAM_MEMBERS_DATA,
                    params: {
                        employeeNo,role,
                    },
                };
            },
            providesTags: ['CoachingShoutOut'],
        }),
        getSystemConfig: builder.query({
            query: (arg: any) => {
                const { configCode } = arg;
                return {
                    url: constants.GET_SYSTEM_CONFIG,
                    params: { configCode },
                };
            },
            providesTags: ['SystemConfig'],
        }),
    }),
});

export const { useCreateCoachingShoutOutMutation, useGetLatestShoutOutQuery, useGetTeamMembersDataQuery, useGetSystemConfigQuery } = CoachingShoutOutSlice;
